import apiRequest from "./apiRequest";

export const getMachinesInfo = async (token) => {
  const payment = await apiRequest.get("/v2/sensors/em/machines", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return payment.data;
};

export const getEmBookingPrice = async (token) => {
  const bookingPrice = await apiRequest.get("/v2/sensors/em/price", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return bookingPrice.data;
};

export const requestBooking = async (params, token) => {
  const booking = await apiRequest.post("/v2/sensors/em/reserve", params, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return booking.data;
};

export const createBookingPayment = async (data, token) => {
  const payment = await apiRequest.post("/v2/sensors/em/book", data, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return payment.data;
};
